// extracted by mini-css-extract-plugin
export default {"root":"_1joZ3","variant-horizontal":"_3JHEI","variantHorizontal":"_3JHEI","title":"bKK_r","message":"Ydj9w","core-star":"_2CCey","coreStar":"_2CCey"};